<template>
  <div id="app">
    <header-block></header-block>
    <div class="lg-none">
      <main-nav></main-nav>
    </div>
    <fixed-nav></fixed-nav>
    <router-view></router-view>
    <footer-block></footer-block>
  </div>
</template>


<script>
import HeaderBlock from "./components/header";
import MainNav from "./components/main-nav";
import FixedNav from "./components/fixed-nav";
import FooterBlock from "./components/footer";
export default {
  components: {
    HeaderBlock,
    MainNav,
    FixedNav,
    FooterBlock
  }
};
</script>



